import { memo } from 'react';

const GroupLabel = ({ group }) => <span>{group.name || 'Other'}</span>;

// eslint-disable-next-line import/no-default-export
export default memo(GroupLabel);
